export default "__VITE_ASSET__JHjnNXhvtUD7lKURXgQELQ__"